module.exports = __webpack_public_path__ + "static/img/icon-guidance.217bf72a.svg";